<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired, isSubOption: isSubOption}">
    <span class="idStkr">
      {{isSubOption ? `${isSubOption.parentLabel}:${isSubOption.parentValue} > ` : ''}}{{itemSetting.action.labelValue}}
    </span>
    <div class="label" :style="labelStyle">{{itemSetting.action.label[activeLang]}}</div>
    <div class="listItem checkbox radio"
      v-for="(option, index) in itemSetting.action.item"
      :key="index"
      :class="{quantityOption: hasQuantity}"
      :style="valueStyle">
      <input type="radio"
        :name="`radio_${id}_${moduleIndex}`"
        :id="`radio_${id}_${moduleIndex}_${index}`"
        :value="option.id || `${index}_${option.value}`"
        :disabled="itemSetting.action.hasDefault !== true"
        v-model="itemSetting.action.defaultValue">
      <label :for="`radio_${id}_${moduleIndex}_${index}`">
        {{option.label[activeLang]}}
        <span class="optionPrice">
          {{optionPrice(option.price)}}
        </span>
      </label>
      <div v-if="hasQuantity" class="quantity">
        <button type="button" class="btnQuantity" data-quantity="minus" disabled>-</button>
        <input type="text"
          class="inputQuantity"
          :placeholder="`${itemSetting.action.min} ~ ${itemSetting.action.max}`"
          :value="option.quantity"
          disabled>
        <button type="button" class="btnQuantity" data-quantity="plus" disabled>+</button>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
export default {
  name: 'RadioModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting',
    'subOption'
  ],
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    currency () {
      return this.$store.getters['setting/getCurrencyCode'].toUpperCase()
    },
    hasQuantity () {
      return this.itemSetting.action.optionQuantity
    },
    isSubOption () {
      const id = this.id
      return this.subOption.find(x => x.child === id)
    }
  },
  methods: {
    optionPrice (price) {
      const code = this.currency
      const disabledSymbol = this.$store.getters['setting/getData']?.currency?.disabledCurrencySymbol ?? false
      return price ? regExp.priceFormat(price, code, disabledSymbol) : ''
    }
  }
}
</script>
